import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import SettingsIcon from '@material-ui/icons/Settings';
import { ROUTE_SETTINGS } from '../../routes/constants';
import i18n from '../../i18n';

class MySettingsMenuLink extends Component {
  render() {
    return (
      <Link className='activeUserChip' to={ROUTE_SETTINGS}>
        <SettingsIcon className='userChipIcon' />
        <span className='userChipText'>{i18n.t('mySettings').toUpperCase()}</span>
      </Link>
    );
  }
}

export default MySettingsMenuLink;
